var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReadRcs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4646 5.60719C10.0925 5.2351 9.47659 5.2351 9.1045 5.60719L4.65221 10.0595L2.76609 8.17335C2.39399 7.80126 1.77812 7.80126 1.40602 8.17335C1.03393 8.54545 1.03393 9.16133 1.40602 9.53342L3.97218 12.0996C4.16464 12.292 4.40843 12.3819 4.65221 12.3819C4.896 12.3819 5.13978 12.292 5.33225 12.0996L10.4646 6.96726C10.8367 6.59517 10.8367 5.97929 10.4646 5.60719Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2356 5.60719L9.10329 10.7395C8.7312 11.1116 8.7312 11.7275 9.10329 12.0996C9.29575 12.292 9.53954 12.3819 9.78332 12.3819C10.0271 12.3819 10.2709 12.292 10.4634 12.0996L15.5957 6.96726C15.9678 6.59517 15.9678 5.97929 15.5957 5.60719C15.2236 5.2351 14.6077 5.2351 14.2356 5.60719Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadRcs);
export default __webpack_public_path__ + "static/media/read-rcs.f78516be23de41472964f8a5033f42ce.svg";
export { ForwardRef as ReactComponent };